<template>
	<div id="editor">
		<div v-if="working" class="d-flex justify-content-center align-items-center" style="min-height:300px">
			<spinner size="huge" message="Updating..."></spinner>
		</div>
		<div v-if="!working">
			<form v-on:submit.prevent="transmitForm">
				<div class="container">
					<div class="head row">
						<div class="col col-sm-3" style="text-align:left">
							<i class="pseudobutton mdi mdi-arrow-right-bold-circle mdi-24px" @click="$emit('closeEditor')"><span style="">Back</span></i>
						</div>
						<div class="col col-sm-9">
							<h3>Edit Registry #<i>{{site.DNS_ID}}</i></h3>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_name">Name</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="s_name" v-model="site.DNS_NAME" id="s_name"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">Admin Url</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="panel_baseurl" v-model="site.DNS_ADMIN_URL" id="panel_baseurl"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="s_domain">Admin User</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="panel_user" v-model="site.DNS_ADMIN_USER" id="panel_user"/>
						</div>
					</div>
					<div class="form-group row">
						<label  class="col-sm-3 col-form-label" for="panel_password">Admin Password</label>
						<div class="col-sm-9">
							<input type="text" class="form-control form-control-sm" name="panel_password" v-model="site.DNS_ADMIN_PWD" id="panel_password"/>
						</div>
					</div>
					<div class="row">
						<div class="col form-group" style="text-align:center">
							<button class="btn btn-success" type="submit">Change</button>
						</div>
						<div class="col form-group" style="text-align:center">
							<button class="btn btn-danger" type="button" @click="assertDelete">Delete</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>
<script>
import Spinner from 'vue-simple-spinner'

export default {

	components: {
		Spinner
	},
	props: ['site', 'servers', 'working', 'registries'],

	data() {
		return {
			renewclass: '',
		}
	},
	created: function() {
	},
	methods: {
		assertDelete() {
			if(confirm("Are you sure you want to remove this Site?")) {
				this.$emit('deleteItem', this.site.DNS_ID)
			}
		},
		transmitForm() {
			var fields = [ 'DNS_ID', 'DNS_NAME', 'DNS_ADMIN_URL', 'DNS_ADMIN_USER', 'DNS_ADMIN_PWD']
			let transfer = {}
			for(var i = 0;i < fields.length;i++) {
				transfer[fields[i]] = this.site[fields[i]]
			}
			this.$emit('updateItem', transfer)
		},
  }
}
</script>
